"use client"
import { actionRecoverPassword } from "./actions"
import { Box, Card, Center, Image, Text, TextInput, Button, rem } from "@mantine/core"
import { useForm } from "@mantine/form"
import { IconChevronRight, IconKey } from "@tabler/icons-react"
import { useState } from "react"
import { z } from "zod"
// import Lottie, { LottieRefCurrentProps } from "lottie-react"
// import animMessageSent from "@/assets/animations/message_sent.json"
import { cn } from "@/lib/utils"
import { showNotification } from "@/lib/notifications"
import Link from "next/link"

export function ClientPage() {
  // const messageSentContainer = useRef<LottieRefCurrentProps>(null)
  const [processState, setProcessState] = useState<"default" | "loading" | "success">("default")

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      email: "",
    },
    validate: {
      email: (value) => {
        const safeEmail = z.string().email().safeParse(value)
        if (!safeEmail.success) {
          return "Invalid email"
        }
        return null
      },
    },
  })

  async function handlePasswordRecovery() {
    if (processState !== "default") return
    form.validate()

    if (form.isValid() === false) return

    const values = form.getTransformedValues()

    try {
      setProcessState("loading")

      await actionRecoverPassword({
        email: values.email,
      })

      setProcessState("success")
    } catch (err) {
      showNotification({
        type: "error",
        title: "Error while recovering password",
        message: (err as any)?.message ?? "Try again in a few seconds or reach your administrator for help.",
      })
      setProcessState("default")
    }
  }

  return (
    <Card padding={"xl"} radius="md" shadow="sm" withBorder className="!overflow-hidden" mih={rem(200)} maw={rem(440)}>
      <Box id="box-present" className={cn("size-full", processState === "success" ? "hidden" : "")}>
        <Box
          className="space-y-3"
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault()
              handlePasswordRecovery()
            }
          }}
        >
          <Box>
            <Text>Enter the email address you normally use for your Ring.io account in the form below.</Text>
            {/* <Text size="sm" c="dimmed">
            If you got here by clicking a link you received in an email message,
            use the email address it was sent to.
          </Text> */}
          </Box>
          <TextInput disabled={processState === "loading"} placeholder="yourmail@domain.com" key={form.key("email")} {...form.getInputProps("email")} />
          <Box className="flex w-full flex-col space-y-2 pt-2">
            <Button loading={processState === "loading"} fullWidth leftSection={<IconKey className="size-4" />} onClick={handlePasswordRecovery}>
              Recover Password
            </Button>
          </Box>
        </Box>
      </Box>

      {processState === "success" && (
        <Box id="box-sent" className={"size-full"}>
          <Box mt={"md"} className="flex flex-col items-center justify-center">
            {/* <Lottie
              className="size-32"
              loop={false}
              autoPlay
              lottieRef={messageSentContainer}
              animationData={animMessageSent}
            /> */}
            <Text className="!text-center">
              An email with instructions on changing your password has been sent to{" "}
              <Text component="span" c="blue">
                {form.getTransformedValues().email}
              </Text>
              .
            </Text>
            <Box className="flex w-full flex-col space-y-2 pt-4">
              <Button fullWidth rightSection={<IconChevronRight className="size-4" />} component={Link} href="/login">
                Go back to login
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  )
}
